(() => {
  if (window.milanisCollectionsReveal || !('IntersectionObserver' in window)) return;
  window.milanisCollectionsReveal = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialized = new WeakSet();
  const pending = new Set();
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer.unobserve(entry.target);
      pending.delete(entry.target);
      if (!reduced.matches) entry.target.classList.add('mvc-reveal');
    }
  }, { threshold: 0.05 });

  function init(root = document) {
    root.querySelectorAll('.mv-collections__card').forEach(card => {
      if (initialized.has(card)) return;
      initialized.add(card);
      const rect = card.getBoundingClientRect();
      // Avoid flashing cards already visible when the script loads.
      if (reduced.matches || (rect.top < window.innerHeight && rect.bottom > 0)) return;
      pending.add(card);
      observer.observe(card);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const card of pending) {
      if (event.target.contains(card)) {
        observer.unobserve(card);
        pending.delete(card);
      }
    }
  });
  reduced.addEventListener('change', () => {
    if (!reduced.matches) return;
    for (const card of pending) observer.unobserve(card);
    pending.clear();
    document.querySelectorAll('.mv-collections__card.mvc-reveal').forEach(card => card.classList.remove('mvc-reveal'));
  });
})();
